// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2VAsx","errorLogs":"styles_errorLogs__YE-Y3"};